import { render, staticRenderFns } from "./MultiMidias.vue?vue&type=template&id=15b23c75&"
import script from "./MultiMidias.vue?vue&type=script&lang=js&"
export * from "./MultiMidias.vue?vue&type=script&lang=js&"
import style0 from "./MultiMidias.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports